import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ConsoleService } from "src/app/shared/services/console.service";
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { DocumentoService } from 'src/app/services/documento.service';
import * as _ from 'lodash'
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { RecorridoService } from "src/app/services/recorrido.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";

@Component({
  selector: 'app-modal-consulta-recorrido-detalle',
  templateUrl: './modal-consulta-recorrido-detalle.component.html',
  styleUrls: ['../consulta-recorrido.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ConsultaRecorridoDetalleComponent implements OnInit {

  // Modales
  @ViewChild('consultaRecorridoDetalle', { static: true }) consultaRecorridoDetalle: ModalDirective;

  formPrecioCosto: FormGroup;

 // Data & tmp
 private rutEmpresa: number
 private sucursalEmpresa: number
 paginationContext: PaginationContext = new PaginationContext()
 loading: boolean = false
 listaMovimientosAll: Array<any> = null
 listaMovimientos: Array<any> = null

 private currentPayload: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private documentoService: DocumentoService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private recorridoService: RecorridoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('DETALLE-CONSULTA-RECORRIDO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
  }

  loadAndShow(documento) {
    // this.productoCodigoOriginal = producto_codigo
    // this.precioCostoOriginal = precio_costo
    this.selectData(documento, 1)
    this.show()
  }

  show() {
    //this.isEditing = false
    this.clearData()
    this.consultaRecorridoDetalle.show()
  }

  hide() {
    this.consultaRecorridoDetalle.hide()
  }
  clearData() {
    //this.formValidatorsService.reset(this.formPrecioCosto)
  }

  // Se consume desde la vista
  selectData(documento, pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber

    //this.listaMovimientos = []
    //this.listaMovimientosAll = []

    //const { fechaDesde, fechaHasta, listaEstado } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        codigo: documento.codigo
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams
    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    this.recorridoService.ObtenerConsultaRecorridoDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta
      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = pageNumber
      this.listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPage(this.paginationContext.CurrentPage)
     // this.calculateTotales()
      this.loading = false
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    // inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.recorridoService.ObtenerConsultaRecorridoDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const {registros} = respuesta
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(registros[0].rutaArchivo)
    })
  }

}
